export default {
      id: "pass-usage",
      viewBox: "0 0 58 68",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#pass",
      toString: function () {
        return this.url;
      }
    }